import { FC } from 'react';
import { Box, Switch } from '@mui/material';
import StyledLabel from 'modules/map/components/daily-dish/components/utils/StyledLabel';
import { FIELD_WIDTHS } from 'modules/map/components/daily-dish/constants';

interface SwitchFieldProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  width?: string;
}

/**
 * Reusable switch field component
 */
export const SwitchField: FC<SwitchFieldProps> = ({
  label,
  checked,
  onChange,
  width = FIELD_WIDTHS.HALF,
}) => {
  return (
    <Box sx={{ width }}>
      <StyledLabel label={label} />
      <Switch checked={checked} onChange={(e) => onChange(e.target.checked)} />
    </Box>
  );
};
